import { render, staticRenderFns } from "./detecation-template-edit.vue?vue&type=template&id=4cca1bd4&scoped=true"
import script from "./detecation-template-edit.vue?vue&type=script&lang=ts"
export * from "./detecation-template-edit.vue?vue&type=script&lang=ts"
import style0 from "./detecation-template-edit.vue?vue&type=style&index=0&id=4cca1bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca1bd4",
  null
  
)

export default component.exports